import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  Help,
  Training,
  Program,
  Speaker,
  Cost,
  AboutBlocks
} from "../../../components/LandingTemplates/kak_privit_detyam_lyubov_k_chteniyu";

const TITLE = 'Онлайн-курс Как научить ребёнка читать быстро и с умом?';
const DESCRIPTION = 'Онлайн-курс Как привить детям любовь к чтению';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: "Pf Din, sans-serif" }}>
      <Screen1/>
      <Help/>
      <Training/>
      <Program/>
      <Speaker/>
      <Cost widget={<GetCourseWidget hash={'a050b4ad1fdc2910d16328fd09f8aa37d1b3702e'} id={'300256'} />}/>
      <AboutBlocks/>
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
